module.exports = __webpack_public_path__ + "static/how-it-works-step-5-957cad5860541d9d9462e91d0f4866c2.png";